import { makeStyles } from '@material-ui/core/styles';

export default function ProdutoCardCss() {
    return makeStyles(theme => ({
        checkboxCenter: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        centerLabel: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'right',
        },
    }));
};
